import { useStore } from "vuex";
import { computed, ref, watch } from "vue";

export function required(field, rulesBase, conditionalRules) {
  const store = useStore();
  const rules = ref(null);
  const label = ref(null);
  const isRequired = ref(false);

  const targetValue = computed(() => {
    if (!field.value.requiredCalc) return undefined;
    let id = field.value.requiredCalc.value_source;

    if (field.value.groupID) {
      id = `${field.value.groupID}-${id}`;
    }
    return store.getters.model[id];
  });

  const groupIndex = computed(() => {
    if (!field.value.requiredCalc) return undefined;
    return field.value.groupIndex;
  });

  const createRules = () => {
    isRequired.value = field.value.required !== false;
    label.value = `<b>${field.value.label}</b>`;
    rules.value = rulesBase;

    if (targetValue.value !== undefined) {
      const test = field.value.requiredCalc.test;
      const value = targetValue.value;
      const i = groupIndex.value;

      isRequired.value = new Function("value", "i", test)(value, i);
    }

    if (isRequired.value) {
      label.value = `${label.value} <span class='required'>*</span>`;
      rules.value = rules.value.required();
    }

    if (conditionalRules && typeof conditionalRules === "function") {
      rules.value = conditionalRules(rules, field, isRequired);
    }
  };

  watch(targetValue, createRules);
  watch(groupIndex, createRules);
  createRules();

  return { rules, label, isRequired };
}
